import React from 'react'
import SalesGoalEditContainer from '../../containers/salesgoalmng/SalesGoalEditContainer'

const SaleGoalEditPage = () => {
  return <SalesGoalEditContainer />
}

export default SaleGoalEditPage